import reportService from "../shared/services/reportService";
import { CANCEL_MESSAGE } from "../shared/services/cancelRequest.service";
import { setLogout } from "./authActions";

const REQUEST_REPORT_FIELDS = "REQUEST_REPORT_FIELDS";
const RESPONSE_REPORT_FIELDS = "RESPONSE_REPORT_FIELDS";
const REQUEST_REPORT_FIELDS_FAILURE = "REQUEST_REPORT_FIELDS_FAILURE";
const RESPONSE_CANCEL_REPORT_FIELDS = "RESPONSE_CANCEL_REPORT_FIELDS";
const CLEAR_REPORT_FIELDS = "CLEAR_REPORT_FIELDS";

const requestReportFieldsAction = () => {
  return {
    type: REQUEST_REPORT_FIELDS,
  };
};

const responseReportFieldsAction = (data, id, type) => {
  return {
    type: RESPONSE_REPORT_FIELDS,
    payload: { data, id, type },
  };
};

const requestReportFieldsFailureAction = (errors) => {
  return {
    type: REQUEST_REPORT_FIELDS_FAILURE,
    errors,
  };
};

const responceCancelReportFieldsAction = () => {
  return {
    type: RESPONSE_CANCEL_REPORT_FIELDS,
  };
};

const getReportFields = (reportId, reportType, fields) => {
  return (dispatch) => {
    dispatch(requestReportFieldsAction());
    dispatch(responseReportFieldsAction(fields, reportId, reportType));
  };
};

const clearReportFieldsAction = () => {
  return {
    type: CLEAR_REPORT_FIELDS,
  };
};

export {
  REQUEST_REPORT_FIELDS,
  RESPONSE_REPORT_FIELDS,
  REQUEST_REPORT_FIELDS_FAILURE,
  RESPONSE_CANCEL_REPORT_FIELDS,
  CLEAR_REPORT_FIELDS,
  requestReportFieldsAction,
  responseReportFieldsAction,
  requestReportFieldsFailureAction,
  responceCancelReportFieldsAction,
  getReportFields,
  clearReportFieldsAction,
};
